import React from "react";
import {
  StyledIconButton,
  StyledToggleButton,
  PrimaryButton,
  SecondaryButton,
} from "../../../components/StyledComponents/Buttons/AuradineButtons.js";
import FilterListIcon from "@mui/icons-material/FilterList";
import FilterList from "@mui/icons-material/FilterList";
import { useState } from "react";
import {
  StyledDialog,
  StyledDialogTitle,
} from "../../../components/StyledComponents/Dialog/Dialog.js";
import {
  H5HeadlineMedium,
  H6HeadlineSmall,
  H8TitleMedium,
} from "../../../components/StyledComponents/Typography/Typography.tsx";

import { DialogContent, FormControl } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import CloseIcon from "@mui/icons-material/Close";
import { Box } from "@mui/material";
import { StyledTextField, StyledFormControl } from "../../../components/StyledComponents/Inputs/Inputs.js";
import usePoolsPageContext from "../../context/usePoolsPageContext.js";
import useAppContextProvider from "../../../AppContext/useAppContextProvider.js";
import { usePostAcceptedPools } from "../../queries/usePostAcceptedPools.ts";
import { useTheme } from "../../../ThemeContext/ThemeContext.js";

export const AddAccessListsDialog = (props) => {
  const {
    setAccessLists,
    setAccessListsCopy,
    openAccessListsDialog,
    accessLists,
    setOpenAccessListsDialog,
    editWhiteListsOn,
    whiteListToDelete,
    accessListEditIndex,
  } = usePoolsPageContext();
  const { refetch } = props;
  const { colors } = useTheme();
  const { setToastMessage, setToastOpen } =
    useAppContextProvider();
  console.log("openAccessListsDialog", accessListEditIndex);
  const {
    control,
    handleSubmit,
    watch,
    setValue,
    trigger,
    reset,
    formState: { errors, isValid },
  } = useForm({
    mode: "all",
    defaultValues: {
      user: "",
      url: "",
    },
  });

  const { mutate: addAcceptedPools } =
    usePostAcceptedPools();

  //set values to when
  React.useEffect(() => {
    if (editWhiteListsOn) {
      console.log(whiteListToDelete);
      setValue("user", whiteListToDelete?.user);
      setValue("url", whiteListToDelete?.url);
    }
  }, [
    editWhiteListsOn,
    whiteListToDelete,
    openAccessListsDialog,
  ]);

  const onSubmit = (data) => {
    const cleanedWhiteLists = accessLists
      ? accessLists.map(
          (item) => `${item.url},${item.user}`
        )
      : [];
    if (editWhiteListsOn) {
      console.log("cleanedWhiteLists", accessListEditIndex);
      const whiteListToDeleteStr = `${whiteListToDelete.url},${whiteListToDelete.user}`;
      const updatedAccessLists = accessLists
        .filter(
          (item, index) => item.id !== accessListEditIndex
        )
        .map((item) => `${item.url},${item.user}`)
        .filter((item) => item !== whiteListToDeleteStr);
      console.log(updatedAccessLists.length);
      console.log("updatedAccessLists", updatedAccessLists);
      const updateString = `${data.url},${data.user}`;
      const updatedAccessList = [
        ...updatedAccessLists,
        updateString,
      ];
      console.log("updatedAccessList", updatedAccessList);

      addAcceptedPools(
        { urls: updatedAccessList },
        {
          onSuccess: async (response) => {
            if (response?.status === "ok") {
              setToastOpen(true);
              setToastMessage(
                "Whitelist Pool updated successfully"
              );
              await refetch();
              setOpenAccessListsDialog(false);
              reset();
            } else {
              setToastOpen(true);
              setToastMessage(
                "Error updating Whitelist Pool list"
              );
              setOpenAccessListsDialog(false);
              reset();
            }
          },
          onError: (error) => {
            setToastOpen(true);
            setToastMessage(
              "Error updating Whitelist Pool list,Error:" +
                error
            );
            setOpenAccessListsDialog(false);
          },
        }
      );
    } else {
      const whiteListStr = `${data.url},${data.user}`;
      const updatedAccessLists = [
        ...cleanedWhiteLists,
        whiteListStr,
      ];
      addAcceptedPools(
        {
          urls: updatedAccessLists,
        },
        {
          onSuccess: async (response) => {
            if (response?.status === "ok") {
              setToastOpen(true);
              setToastMessage(
                "Whitelist added successfully"
              );
              await refetch();
              setOpenAccessListsDialog(false);
            } else {
              setToastOpen(true);
              setToastMessage(
                `Error adding Whitelist ${response?.msg}`
              );
              setOpenAccessListsDialog(false);
            }
          },
          onError: (error) => {
            setToastOpen(true);
            setToastMessage(
              "Error adding Whitelist,Error:" + error
            );
            setOpenAccessListsDialog(false);
          },
        }
      );
    }
  };

  return (
    <StyledDialog
      colors={colors}
      maxWidth={"lg"}
      open={openAccessListsDialog}
      hideBackdrop
    >
      <StyledDialogTitle sx={{ paddingTop: 0 }}>
        <Box
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"space-between"}
        >
          <H5HeadlineMedium style={{ textAlign: "left" }}>
            {!editWhiteListsOn
              ? `Add to your Whitelist Pools List`
              : `Edit your Whitelist Pools List`}
          </H5HeadlineMedium>
          <StyledIconButton
            colors={colors}
            onClick={() => {
              setOpenAccessListsDialog(false);
              reset();
            }}
            style={{ textAlign: "right" }}
          >
            <CloseIcon />
          </StyledIconButton>
        </Box>
      </StyledDialogTitle>
      <DialogContent sx={{ padding: 0 }}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Box
            display={"flex"}
            flexDirection={"column"}
            gap={8}
          >
            <Box
              display={"flex"}
              flexDirection={"column"}
              gap={4}
              className="url-details-container"
            >
              <H8TitleMedium>Enter the user</H8TitleMedium>
              <Box
                display="flex"
                flexDirection="row"
                flexGrow={1}
              >
                <StyledFormControl colors={colors} fullWidth margin="none">
                  <Controller
                    name="user"
                    control={control}
                    rules={{
                      required: "User is required",
                      validate: (value) => {
                        if (value.trim() === "") {
                          return "User cannot be empty or spaces only";
                        }
                        if (value.includes(",")) {
                          return "User cannot contain commas";
                        }
                        return true;
                      },
                    }}
                    render={({ field }) => (
                      <StyledTextField colors={colors}
                        {...field}
                        variant="outlined"
                        label="User"
                        fullWidth
                        error={!!errors.user}
                        onChange={(event) => {
                          const value =
                            event.target.value.trim();
                          field.onChange(value);
                        }}
                        onBlur={() => trigger("user")}
                        helperText={
                          errors.user?.message || ""
                        }
                      />
                    )}
                  />
                </StyledFormControl>
              </Box>
            </Box>
            <Box
              display={"flex"}
              flexDirection={"column"}
              gap={4}
              className="url-details-container"
            >
              <H8TitleMedium>Enter the URL</H8TitleMedium>
              <Box
                display="flex"
                flexDirection="row"
                flexGrow={1}
              >
                <StyledFormControl colors={colors} fullWidth margin="none">
                  <Controller
                    name="url"
                    rules={{
                      required: "URL is required",
                      validate: (value) =>
                        value.trim() !== "" ||
                        "URL cannot be empty or spaces only",
                    }}
                    control={control}
                    render={({ field }) => (
                      <StyledTextField colors={colors}
                        {...field}
                        variant="outlined"
                        label="URL"
                        error={!!errors.url}
                        fullWidth
                        onBlur={() => trigger("url")}
                        onChange={(event) => {
                          const value =
                            event.target.value.trim();
                          field.onChange(value);
                        }}
                        helperText={
                          errors.url?.message || ""
                        }
                      />
                    )}
                  />
                </StyledFormControl>
              </Box>
            </Box>

            <Box
              display={"flex"}
              flexDirection={"row"}
              justifyContent={"flex-end"}
              gap={4}
              className="action-button-container"
            >
              <PrimaryButton colors={colors}
                disabled={!isValid}
                type="submit"
                onClick={handleSubmit(onSubmit)}
              >
                Add
              </PrimaryButton>
            </Box>
          </Box>
        </form>
      </DialogContent>
    </StyledDialog>
  );
};
